import { useMonarchRule } from "../MonarchRulesProvider";
import { AbandonedCartTestData, UseAbandonedCart } from "./types";

const CUSTOM_RULE_ID = "abandonedCart";

const useAbandonedCart: UseAbandonedCart = () => {
  const { isLoading, value } = useMonarchRule<{
    data: AbandonedCartTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const { data } = value;
  const variant = data?.enabled ? "test" : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useAbandonedCart;
